import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './CourtPricingNew.css';
import axios from 'axios';
import Swal from 'sweetalert2';
import { FiChevronDown, FiRefreshCw } from 'react-icons/fi';
import Select from 'react-select';
import { useUser } from '../context/UserContext';

const CourtPricingNew = () => {
  const location = useLocation();
  const { selectedCenter } = useUser();
  const [sportsOptions, setSportsOptions] = useState([]);
  const [courtTypeOptions, setCourtTypeOptions] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [price, setPrice] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const token = localStorage.getItem('auth-token');
  const [selectedSport, setSelectedSport] = useState();
  const [selectedCourtType, setSelectedCourtType] = useState(null);


  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_SPORT_COURT_TYPE}?academyIds=${selectedCenter}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    })
      .then((response) => {
        if (response.data.success) {
          const sportsData = response.data.data_list;
          const formattedSports = sportsData.map(item => ({
            value: item.sportId,
            label: item.sportName,
          }));
          setSportsOptions(formattedSports);

          const formattedCourtTypes = sportsData.reduce((acc, item) => {
            if (item.CourtTypes && Object.keys(item.CourtTypes).length > 0) {
              const courtTypes = Object.entries(item.CourtTypes).map(([key, value]) => ({
                value: key,
                label: value,
              }));
              acc[item.sportId] = courtTypes;
            } else {
              acc[item.sportId] = [];
            }
            return acc;
          }, {});

          if (formattedSports.length > 0) {
            const defaultSport = formattedSports[0];
            setSelectedSport(defaultSport);
            const defaultCTs = formattedCourtTypes[defaultSport.value] || [];
            setCourtTypeOptions(defaultCTs);


            if (defaultCTs.length) {
              setSelectedCourtType(defaultCTs[0]);
            }
          }
        }
      })
      .catch((error) => console.error('Error fetching sports data:', error));
  }, [selectedCenter, token]);

  useEffect(() => {
    if (selectedSport) {
      const selectedSportId = selectedSport.value;
      axios.get(`${process.env.REACT_APP_API_SPORT_COURT_TYPE}?academyIds=${selectedCenter}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      })
        .then((response) => {
          if (response.data.success) {
            const sportsData = response.data.data_list;
            const sportData = sportsData.find(sport => sport.sportId === selectedSportId);
            if (sportData && sportData.CourtTypes) {
              const courtTypes = Object.entries(sportData.CourtTypes).map(([key, value]) => ({
                value: key,
                label: value,
              }));
              setCourtTypeOptions(courtTypes);
              setSelectedCourtType(courtTypes[0] || null);
            } else {
              setCourtTypeOptions([]);
              setSelectedCourtType(null);
            }
          }
        })
        .catch((error) => console.error('Error fetching court types:', error));
    }
  }, [selectedSport, selectedCenter, token]);

  useEffect(() => {
    if (selectedSport) {
      const sportId = selectedSport.value;
      const courtTypes = sportsOptions.reduce((acc, sport) => {
        if (sport.value === sportId) {
          acc = sport.CourtTypes;
        }
        return acc;
      }, []);

      setCourtTypeOptions(courtTypes || []);
      setSelectedCourtType(courtTypes && courtTypes.length > 0 ? courtTypes[0] : null);
    }
  }, [selectedSport, sportsOptions]);

  const refreshData = async () => {
    if (!selectedSport || !selectedCourtType) return;

    setLoading(true);
    setError(null);

    try {
      const sportId = selectedSport.value;
      const courtTypeId = selectedCourtType.value;
      const res = await fetch(
        `${process.env.REACT_APP_API_COURT_NEW_PRICE_LIST}?academyId=${selectedCenter}&sportId=${sportId}&courtTypeId=${courtTypeId}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        }
      );
      const result = await res.json();
      if (!result.success) {
        throw new Error(result.success_message || 'Failed to fetch pricing.');
      }

      const courtTypes = result.data.data.sports[0].courtTypes;

      const formatTime = timeStr => {
        let [hh, mm] = timeStr.split(':').map(Number);
        const ampm = hh >= 12 ? 'PM' : 'AM';
        hh = hh % 12 || 12;
        return `${hh}:${String(mm).padStart(2, '0')} ${ampm}`;
      };

      const flat = courtTypes.flatMap(ct =>
        ct.timeRanges.map(tr => ({
          id: `${ct.courtTypeId}_${tr.originalId}`,
          dayRange: tr.fromDay === tr.toDay ? tr.fromDay : `${tr.fromDay}-${tr.toDay}`,
          courtType: ct.courtType,
          courtTypeId: ct.courtTypeId,
          slot: `${formatTime(tr.startTime)} - ${formatTime(tr.endTime)}`,
          price: tr.hourlyPricing,
          fromDay: tr.fromDay,
          toDay: tr.toDay  
        }))
      );

      const grouped = Object.values(
        flat.reduce((acc, { id, dayRange, courtType, courtTypeId, slot, price, fromDay, toDay }) => {
          const key = `${dayRange}_${courtTypeId}`;
          if (!acc[key]) {
            acc[key] = {
              id: key,
              dayRange,
              courtType,
              courtTypeId,
              fromDay,  
              toDay,     
              timings: []
            };
          }
          acc[key].timings.push({ slot, price });
          return acc;
        }, {})
      );
      
      setPrice(grouped);
    } catch (err) {
      console.error('Error fetching pricing:', err);
      setError(err.message || 'Something went wrong while fetching pricing data.');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    refreshData();
  }, [selectedCenter, selectedSport, selectedCourtType]);

  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setrowsPerPage] = useState(10);
  const handleSearchChange = (e) => setSearchTerm(e.target.value);

  const handlePageClick = (pageNumber) => setCurrentPage(pageNumber);

  const sortedBenefits = [...price].sort((a, b) => {
    if (!sortConfig.key) return 0;
    let aValue = a[sortConfig.key];
    let bValue = b[sortConfig.key];

    if (typeof aValue === 'string') {
      aValue = aValue.toLowerCase();
      bValue = bValue.toLowerCase();
    }

    if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
    if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
    return 0;
  });

  const filtered = sortedBenefits.filter((b) => {
    const matchesSearch = Object.values(b)
      .flatMap(v => Array.isArray(v) ? v : [v])
      .join(' ')
      .toLowerCase()
      .includes(searchTerm.toLowerCase());


    return matchesSearch;
  });

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filtered.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(filtered.length / rowsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(prev => prev + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(prev => prev - 1);
  };

  const handleItemsPerPageChange = (event) => {
    setrowsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const generatePageNumbers = () => {
    const pages = [];
    const totalPagesToShow = 5;

    if (totalPages <= totalPagesToShow) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      pages.push(1);
      if (currentPage > 3) pages.push('...');
      for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
        pages.push(i);
      }
      if (currentPage < totalPages - 2) pages.push('...');
      pages.push(totalPages);
    }
    return pages;
  };

  const renderPagination = () => generatePageNumbers().map((page, index) =>
    typeof page === 'number' ? (
      <button
        key={index}
        className={`page-number ${currentPage === page ? 'active' : ''}`}
        onClick={() => handlePageClick(page)}
      >
        {page}
      </button>
    ) : (
      <span key={index} className="pagination-dots">{page}</span>
    )
  );

  const totalEntries = filtered.length;
  const indexOfFirstEntry = totalEntries > 0 ? (currentPage - 1) * rowsPerPage + 1 : 0;
  const indexOfLastEntry = totalEntries > 0 ? Math.min(currentPage * rowsPerPage, totalEntries) : 0;

  const handleEdit = (courtTypeId, sportId, group) => {
    navigate('/createCourtPricing', {
      state: {
        academyId: selectedCenter,
        sportId,
        courtTypeId,
        fromDays: group.fromDay, 
        toDays: group.toDay   
      }
    });
  };
  
  const handleNewBenefit = () => {
    navigate('/createCourtPricing', {
      state: { academyId: selectedCenter, }
    });
  };

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };
  const handleDelete = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        setPrice(prev => prev.filter(item => item.id !== id));
        Swal.fire('Deleted!', 'Court pricing has been deleted.', 'success');
      }
    });
  };

  return (
    <div className="enrollment-container">
      <div className="sales-filters-login">
        <div className="floating-select">
          <Select
            options={sportsOptions}
            value={selectedSport}
            onChange={setSelectedSport}
            placeholder="Sport"
            className={`sales-filter-court-booking ${selectedSport ? "has-value" : ""}`}
            menuPortalTarget={document.body}
            styles={{
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            classNamePrefix="react-select"
          />
          {selectedSport && <label htmlFor="selectedSport">Sport</label>}
        </div>

        <div className="floating-select">
          <Select
            options={courtTypeOptions}
            value={selectedCourtType}
            onChange={setSelectedCourtType}
            placeholder="Court Type"
            className={`sales-filter-court-booking ${selectedCourtType ? "has-value" : ""}`}
            menuPortalTarget={document.body}
            styles={{
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            classNamePrefix="react-select"
          />
          {selectedCourtType && <label htmlFor="courtTypeFilter">Court Type</label>}
        </div>


      </div>
      <div className="search-bar">
        <div className="input-container">
          <input
            type="text"
            id="searchInput"
            placeholder=""
            className={`search-input ${searchTerm ? "has-value" : ""}`}
            value={searchTerm}
            onChange={handleSearchChange}
          />
          <label htmlFor="searchInput" className="floating-label">🔍 Search</label>
        </div>

        <button className="create-button-new" onClick={handleNewBenefit}>
          <span className="create-button__icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="23" height="23" className="create-button__svg">
              <path d="M12 5v14M5 12h14" stroke="white" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
          <span className="create-button__label">Create Court Price</span>
        </button>
      </div>


      <div className="items-and-dues">
        <select className="items-per-page-select" value={rowsPerPage} onChange={handleItemsPerPageChange}>
          <option value={10}>10 items per page</option>
          <option value={50}>50 items per page</option>
          <option value={75}>75 items per page</option>
        <option value={100}>100 items per page</option>
      </select>
      <div className="pagination-selector">
          <div className="button-group">
            <div className="group-label">Items per page:</div>
            <div className="button-options">
              {[10, 50, 75, 100].map((option) => (
                <button
                  key={option}
                  onClick={() =>
                    handleItemsPerPageChange({ target: { value: option } })
                  }
                  className={`page-button ${rowsPerPage === option ? 'active' : ''}`}
                >
                  <span className="button-text">{option}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
        <button className="tt-action-btn" onClick={refreshData}>
          <FiRefreshCw className={`refresh-icon ${loading ? 'spin' : ''}`} />
          Refresh
        </button>
      </div>

      

      <div className="tt-table-container">
        {loading ? (
          <div className="tt-loading">
            <div className="tt-loading-spinner"></div>
            <p>Loading CourtPricing...</p>
          </div>
        ) : (
          <table className="tt-table">
            <thead>
              <tr>
                <th>Timing</th>
                <th>Price</th>
              </tr>
            </thead>
            <tbody>
              {currentRows.length > 0 ? (
                currentRows.map(group => (
                  <React.Fragment key={group.id}>
                    <tr className="group-header-row">
                      <td
                        colSpan={2}
                        style={{
                          fontWeight: 'bold',
                          background: '#f1f6fa',
                          color: '#15559a',
                          fontSize: '1.07rem',
                          borderTop: '2px solid #d8e7fa',
                          paddingRight: '24px',
                          position: 'relative'
                        }}
                      >
                        <span style={{ verticalAlign: 'middle' }}>{group.dayRange}</span>
                        <button
                          className="edit-btn tooltip-btn"
                          onClick={() => handleEdit(group.courtTypeId, selectedSport.value, group)}
                          title="Edit"
                          style={{
                            float: 'right',
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            padding: 0,
                            marginLeft: 8,
                            verticalAlign: 'middle'
                          }}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" fill="none" viewBox="0 0 24 24" stroke="#15559a" strokeWidth="2">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M16.862 3.487a2.12 2.12 0 0 1 3.001 3.001L7.5 18.85l-4 1 1-4L16.862 3.487z" />
                          </svg>
                          <span className="tooltip-text">Edit</span>
                        </button>
                      </td>
                    </tr>
                    {/* Timing rows */}
                    {group.timings.map((t, idx) => (
                      <tr key={group.id + '-' + idx}>
                        <td style={{ paddingLeft: '30px' }}>{t.slot}</td>
                        <td>₹{t.price}</td>
                      </tr>
                    ))}
                  </React.Fragment>
                ))
              ) : (
                <tr>
                  <td colSpan="2" style={{ textAlign: 'center' }}>No pricing found</td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>

      <div className="pagination">
        <div className="showing-entries">
          Showing {indexOfFirstEntry} to {indexOfLastEntry} of {totalEntries} entries
        </div>
        <button className="prev-button" onClick={handlePrevPage} disabled={currentPage === 1}>Previous</button>
        {renderPagination()}
        <button className="next-button" onClick={handleNextPage} disabled={currentPage === totalPages}>Next</button>
      </div>
    </div>
  );
};

export default CourtPricingNew;
